module.exports = __webpack_public_path__ + "media/images/svg/clients/9-2b557de807c9a5eda1ba0b95f0289c8a.svg";